<template>
    <div class="d-flex flex-wrap flex-stack my-5">
        <router-link to="/timetable" class="btn btn-primary align-self-center">
            <span class="svg-icon svg-icon-2">
                <inline-svg src="/media/icons/duotune/arrows/arr021.svg" />
            </span>
            {{ $t("menu.timetable") }}
        </router-link>
    </div>
    <div class="card w-100" id="kt_drawer_chat_messenger">
        <div class="card-header pe-5" id="kt_drawer_chat_messenger_header">
            <div class="card-title">
                <div class="d-flex justify-content-center flex-column me-3">
                    <a href="#" class="fs-4 fw-bolder text-gray-900 text-hover-primary me-1 mb-2 lh-1">{{ $t('pages.timetable.session.chat.title') }}</a>
                </div>
            </div>
        </div>
        <div class="card-body" id="kt_drawer_chat_messenger_body">
            <div class="scroll-y me-n5 pe-5"  id="messageScroll" ref="messagesRef" data-kt-element="messages" data-kt-scroll="true" data-kt-scroll-activate="true" data-kt-scroll-height="auto" data-kt-scroll-dependencies="#kt_drawer_chat_messenger_header, #kt_drawer_chat_messenger_footer" data-kt-scroll-wrappers="#kt_drawer_chat_messenger_body" data-kt-scroll-offset="300px">
                <template v-for="(message, messageIndex) in chatMessages" :key="messageIndex">
                    <MessageOut ref="messagesOutRef"  v-if="message.ownerable_type === 'INSTRUCTOR'" :name="message.ownerable.full_name" :time="$moment(message.created_at).format('DD.MM.YYYY - HH:mm:ss')" :text="message.content" :image="'/media/avatars/blank.png'"></MessageOut>
                    <MessageIn ref="messagesInRef" v-else :name="message.ownerable.full_name" :time="$moment(message.created_at).format('DD.MM.YYYY - HH:mm:ss')" :text="message.content" :image="'/media/avatars/blank.png'"></MessageIn>
                </template>
            </div>
        </div>

        <div class="card-footer pt-4" id="kt_drawer_chat_messenger_footer">
            <input class="form-control form-control-flush mb-3" data-kt-element="input" :placeholder="$t('pages.ticket.detail.message.cols.content')" v-model="form.data.content" v-on:keyup.enter="onSubmit"/>

            <div class="d-sm-flex flex-stack d-inline-block">
                <button @click="onSubmit" :data-kt-indicator="form.loading ? 'on' : null" class="btn btn-primary mt-7 mt-sm-0" type="button" :disabled="form.loading">
                    <span v-if="!form.loading" class="indicator-label">{{ $t("common.send") }}</span>
                    <span v-if="form.loading" class="indicator-progress">
                        {{ $t("messages.wait") }}
                        <span class="spinner-border spinner-border-sm align-middle ms-2"></span>
                    </span>
                </button>
            </div>
        </div>
    </div>
</template>

<script>
import MessageIn from "@/components/messenger-parts/MessageIn.vue";
import MessageOut from "@/components/messenger-parts/MessageOut.vue";
import {ScrollComponent} from "@/assets/js/components/_ScrollComponent";

export default {
    name: "_id",
    components: {
        MessageIn,
        MessageOut
    },
    data() {
        return {
            form: {
                loading: false,
                data: {}
            },
            chatMessages: [],
            chatInterval: null,
        }
    },
    computed: {
        sessionID() {
            return this.$route.params.id;
        },
    },
    created() {
        if (!this.sessionID || !(this.sessionID > 0)) {
            this.$router.push({
                path: "/timetable"
            });
        }
    },
    mounted() {
        if (this.sessionID && this.sessionID > 0) {
            this.loadChat();
        }

        let instance = ScrollComponent.createInstance(document.querySelector('#messageScroll'));
        instance.update();

        this.startChatInterval();
    },
    methods: {
        loadChat(){
            this.axios.get(this.endpoint.get('ecommerce_course_session_chat'), {
                params: {
                    course_session_id: this.sessionID
                }
            }).then(response => {
                let data = response.data.data;
                let updateScroll = (!this.chatMessages || this.chatMessages && this.chatMessages.length != data.messages.length);

                this.chatMessages = data.messages ?? [];

                if(updateScroll) {
                    setTimeout(() => {
                        if (this.$refs.messagesRef) {
                            this.$refs.messagesRef.scrollTop = this.$refs.messagesRef.scrollHeight;
                        }
                    }, 1);
                }
            });
        },
        onSubmit(){
            if(!(this.form.data.content && this.form.data.content.trim().length > 0)){
                this.$notify({
                    type: 'warning',
                    title: this.$t("messages.warning"),
                    message: this.$t("pages.timetable.session.chat.warning.message"),
                })
                return false;
            }

            this.form.data.course_session_id = this.sessionID;
            this.form.loading = true;

            this.axios.post(this.endpoint.get('ecommerce_course_session_chat'), this.form.data).then(response => {
                this.onResponse(response.data, () => {
                    this.loadChat();
                    this.form.data = {};
                });
            }).catch(error => {
                this.onResponseFailure(error.response.data);
            }).finally(() => {
                this.form.loading = false;
            });
        },
        startChatInterval(){
            if(this.chatInterval) {
                clearInterval(this.chatInterval);
            }

            this.chatInterval = setInterval(() => {
                this.loadChat();
            }, 10000);
        }
    },
    unmounted(){
        if(this.chatInterval) {
            clearInterval(this.chatInterval);
        }
    }
}
</script>

<style scoped>

</style>